export enum PromoCodeType {
  SUBSCRIPTION = 'SUBSCRIPTION',
  PRODUCT = 'PRODUCT'
}
